import { profileStore } from '@entities/profile'
import { useAction, useAppSelector } from '@shared/lib/redux'

export const useUpdateProfile = () => {
  const state = useAppSelector(profileStore.selectors.selectStatus)
  const updateProfile = useAction(profileStore.actions.updateProfileStart)
  return {
    updateProfile,
    ...state
  }
}

export const useSetProfile = () => {
  const setProfile = useAction(profileStore.actions.setProfile)
  return {
    setProfile
  }
}
